import storage from '@shared/storage'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

@Component
export default class MixinAuthentication extends Vue {
  public login() {
    return new Promise((resolve, reject) => {
      this.$feathers.passport.getJWT()
        .then(async (jwt) => {
          if (jwt) {
            const response = await this.authenticate()
            resolve(response)
          } else {
            const userKey = storage.getItem('userKey')
            if (!userKey) {
              this.$router.push({ name: 'login' })
              reject()
            }

            const response = await this.authenticate({ key: userKey })
            resolve(response)
          }
        })
    })
  }

  public async authenticate(credentials: any = null): Promise<any> {
    try {
      if (!credentials) {
        // Try to authenticate using the JWT from localStorage
        return await this.$feathers.authenticate()
      } else {
        await this.$feathers.logout()

        const payload = Object.assign({ strategy: 'key' }, credentials)
        await this.$feathers.authenticate(payload)

        return this.authenticate()
      }
    } catch (error) {
      // error, route back to login?
      this.$router.push({ name: 'login' })
    }
  }
}
